export default "__VITE_ASSET__YPHLMeXr__"